import { render, staticRenderFns } from "./ShareCertificateModal.vue?vue&type=template&id=d7dccab6"
import script from "./ShareCertificateModal.vue?vue&type=script&lang=js"
export * from "./ShareCertificateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports